import { render, staticRenderFns } from "./manifesto.vue?vue&type=template&id=808f6f7c&scoped=true"
import script from "./manifesto.vue?vue&type=script&lang=js"
export * from "./manifesto.vue?vue&type=script&lang=js"
import style0 from "./manifesto.vue?vue&type=style&index=0&id=808f6f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808f6f7c",
  null
  
)

export default component.exports